import apiClient from "./client";

export async function fetchImageLikeCounts(imageIds = [], signal) {
  const ids = imageIds.filter(Boolean).join(",");
  if (!ids) {
    return { images: [] };
  }
  const response = await apiClient.get("likes/images/", {
    params: { ids },
    signal,
  });
  return response.data;
}

export async function toggleImageLike(imageId, action = "like") {
  const response = await apiClient.post(`likes/images/${imageId}/`, { action });
  return response.data;
}

export async function toggleProfileLike(userId, action = "like") {
  const response = await apiClient.post(`likes/profiles/${userId}/`, { action });
  return response.data;
}
